// extracted by mini-css-extract-plugin
export default {"constructDrag":"constructor-drag_constructDrag__2IIql"};